import * as api from '../../api';
import { router } from '../../router/index';

const pub = {
  state: {
    columns: [],
    codeTreeNode: []
  },
  mutations: {
    GETCOLUMNS(state, data) {
      state.columns = data;
    },
    GETCODETREE(state, data) {
      state.codeTreeNode = [];
      data.forEach(function (val, index) {
        state.codeTreeNode.push({ title: val.columnName, id: val.columnName });
      });
    }
  },
  getters: {
    getColumns(state) {
      return state.columns;
    },
    getCodeTreeNodes(state) {
      return state.codeTreeNode;
    }
  },
  actions: {
    getColumnsAction({ commit }, params) {
      api.getColumnsResource(params).then(function (response) {
        commit("GETCOLUMNS", response.body);
        commit("GETCODETREE", response.body);
      }, function (response) {
        console.log("==error==", response);
      });

    }
  }
};

export default pub;



// WEBPACK FOOTER //
// ./src/store/modules/common.js